// extracted by mini-css-extract-plugin
export default {"title":"ZNrlc","list":"Sf0sj","item":"fa7Tm","subTitle":"vDtzl"};